export { default, StyledPrice } from './Price'
export type { PriceProps } from './Price'
export { PriceWrapper, PriceText } from './PriceWrapper'
